import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p399341158298337280',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
